import { Typography } from '@/components';
import { TextStyles } from '@/constants';
import { Chip } from '@/modules/pmt/components/Chip';
import styled from 'styled-components';

export const Label = styled(Typography).attrs({
  variant: TextStyles['Body Text Small'],
})({
  flex: 1,
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  textAlign: 'left',
  textTransform: 'capitalize',
  WebkitFontSmoothing: 'auto',
});

export const ChipWrapper = styled(Chip)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing[8],
  width: '100%',
}));
